import React from "react";

const Title = () => {
  return (
    <div className="title">
      <h1 className="logo">Uttarpurusha Theatre Group</h1>
      <div className="logo-container">
        <div className="logo-border">

      <img className="logo-img" src="https://www.uttarpurushtheater.com/assets/img/logo.jpeg" alt="" />
        </div>
      </div>
      <h2>Our Pictures Gallery</h2>
      <p>All of our memories and the ones we’ll make together start her. </p>
    </div>
  );
};

export default Title;
